import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height"},[_c('radial-bar-chart',{staticClass:"fill-height",attrs:{"series":[ _vm.getStatValue('CALETLDLHSR_G') || 0 ],"plot-options":{
      radialBar: {
        startAngle: -90,
        endAngle: 90,
        dataLabels: {
          name: {
            show: false
          },
          value: {
            offsetY: _vm.getStatValue('CALETLDLHSR') ? -2 : 25,
            fontSize: '24px'
          },
          total: {
            show: true,
            label: _vm.getStatValue('CALETLDLHSR'),
            formatter: function () { return _vm.getStatValue('CALETLDLHSR') ? _vm.getStatValue('CALETLDLHSR') : 'N/A'; }
          }
        }
      }
    },"tooltip":{
      enabled: true,
      y: {
        formatter: function () { return ((_vm.getStatValue('CALETLDLHSR_G')) + "%"); },
        title: {
          formatter: function () { return _vm.getVariableName('CALETLDLHSR_G') + ':'; }
        }
      }
    },"animations":{enabled: false}},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c(VCardTitle,{staticClass:"pa-6 d-flex justify-space-between"},[_c('div',{staticClass:"subtitle-2 grey--text text--grey-100"},[_vm._v(" "+_vm._s(_vm.$t("card_title.high_speed_running"))+" ("+_vm._s(_vm.getVariableSuffix('CALETLDLHSR'))+")"+_vm._s(_vm.aggregation ? ": " + _vm.$t(("variables." + _vm.aggregation + ".long")) : '')+" ")]),(_vm.removable)?_c(VBtn,{staticStyle:{"pointer-events":"auto"},attrs:{"icon":""},on:{"click":function($event){return _vm.$emit('remove')}}},[_c(VIcon,{attrs:{"small":""}},[_vm._v(" fal fa-times ")])],1):_vm._e()],1)]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }